import { PropsWithChildren, createContext, useContext, useMemo, useState } from 'react';

interface StripeNotificationsContextType {
    hasFetchedNotifications: boolean;
    setHasFetchedNotifications: (value: boolean) => void;
    hasNotifications: boolean;
    setHasNotifications: (value: boolean) => void;
}

const StripeNotificationsContext = createContext<StripeNotificationsContextType | undefined>(
    undefined,
);

export const StripeNotificationsProvider = ({ children }: PropsWithChildren) => {
    const [hasFetchedNotifications, setHasFetchedNotifications] = useState(false);
    const [hasNotifications, setHasNotifications] = useState(false);

    const ctx = useMemo(
        () => ({
            hasFetchedNotifications,
            setHasFetchedNotifications,
            hasNotifications,
            setHasNotifications,
        }),
        [
            hasFetchedNotifications,
            setHasFetchedNotifications,
            hasNotifications,
            setHasNotifications,
        ],
    );

    return (
        <StripeNotificationsContext.Provider value={ctx}>
            {children}
        </StripeNotificationsContext.Provider>
    );
};

export const useStripeNotifications = () => {
    const context = useContext(StripeNotificationsContext);
    if (!context) {
        throw new Error('useStripeNotifications must be used within a StripeNotificationsProvider');
    }
    return context;
};
